import React from 'react';
import { Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { MenuItem } from 'react-bootstrap';
import {rgbToAlfa} from '../../../../selectors/UtilSelectors';

const TagProps = {
    id: PropTypes.number,
    name: PropTypes.string,
    categoryName: PropTypes.string,
    eventId: PropTypes.number,
    subTags: PropTypes.arrayOf(PropTypes.shape(
        {
            id: PropTypes.number,
            parentId: PropTypes.number,
            name: PropTypes.string,
            categoryName: PropTypes.string
        }
    ))
};

const TagsBoxProps = {
    id: PropTypes.number.isRequired,
    categoryName: PropTypes.string,
    tags: PropTypes.arrayOf(PropTypes.shape(TagProps)),
    toggleTag: PropTypes.func.isRequired,
    clearCategoryTags: PropTypes.func,
    color: PropTypes.string
};

const TagsBox = props => {
    const { tags: tagsColl, toggleTag, clearCategoryTags, id, color } = props;

    const tagProps = (isSelected) => ({
        className: 'tag',
        style: isSelected ? {
            color: color,
            borderColor: color,
            fontWeight: '600',
            backgroundColor: `color-mix(in srgb, ${color} 15%, transparent)`,
        } : { borderColor: '#76778C'}
    });

    const renderSubTags = (subTags, toggleTag) => subTags.map((tag, i) => {
        const { categoryName, id: tagId, isSelected } = tag;
        return (
            <div {...tagProps(isSelected)} onClick={() => toggleTag(categoryName, tagId)} key={++i}>
                {tag.name}
            </div>
        );
    });

    const tags = tagsColl.map((tag, i) => {
        const { isSelected, id: tagId, name, subTags, categoryName } = tag;
        return (
            <div key={i}>
                <div className="tags-row-wrapper">
                    <div className="tags-wrapper">
                        <div {...tagProps(isSelected)} onClick={() => toggleTag(categoryName, tagId)} >
                            {name}
                        </div>
                    </div>
                    {
                        subTags.length > 0 &&
                    <Fragment>
                        <div className="tags-wrapper">
                            <div className="dash">-</div>
                        </div>
                        <div className="tags-wrapper">
                            {
                                renderSubTags(subTags, toggleTag)
                            }
                        </div>
                    </Fragment>
                    }
                </div>
            </div>
        );
    });

    return (
        <Fragment>
            <div className="hidden-xs tags-box-wrapper">
                <div className="tags-box">{tags}</div>
                <div className="clearfix">
                    <div className="clear-tags clearfix custom-color color-1" onClick={() => clearCategoryTags(id)}>Clear All</div>
                </div>
            </div>
            <div className="visible-xs tags-box-wrapper-mobile">
                <div>{tags}</div>
                <div className="clearfix">
                    <div className="clear-tags clearfix custom-color color-1" onClick={() => clearCategoryTags(id)}>Clear All</div>
                </div>
            </div>
        </Fragment>
    );
};

TagsBox.propTypes = TagsBoxProps;

const NestedTagsFilterProps = {
    type: PropTypes.string.isRequired,
    selectedCategoryId: PropTypes.number.isRequired,
    filters: PropTypes.arrayOf(PropTypes.shape(
        {
            id: PropTypes.number,
            name: PropTypes.string,
            tags: PropTypes.arrayOf(PropTypes.arrayOf(TagProps))
        }
    )),
    toggleTag: PropTypes.func.isRequired,
    selectFilterCategory: PropTypes.func.isRequired,
    clearCategoryTags: PropTypes.func.isRequired,
    color: PropTypes.string
};

const NestedTagsFilter = props => {
    const { filters, toggleTag, selectFilterCategory, selectedCategoryId, clearCategoryTags, color } = props;
    return (
        <Fragment>
            {
                filters.map((filter, index) => {
                    const tagsBoxProps = {
                        ...filter,
                        toggleTag,
                        clearCategoryTags,
                        color
                    };

                    const isSelected = selectedCategoryId === filter.id;
                    const clsMenuItem = classnames({'custom-color color-1': isSelected});
                    const clsCategory = classnames('category', {'selected': isSelected});

                    const menuItemProps = {
                        eventKey: filter.id,
                        onSelect: selectFilterCategory,
                        active: isSelected,
                        className: clsMenuItem
                    };

                    return (
                        <div className={clsCategory} key={index}>
                            <MenuItem {...menuItemProps}>
                                <span style={isSelected ? {color} : {}}>{filter.name}</span><i className="fa icon-AgendaAtt_arrow custom-color color-1"/>
                            </MenuItem>
                            {isSelected && <TagsBox {...tagsBoxProps} /> }
                        </div>
                    );
                })
            }
        </Fragment>
    );
};

NestedTagsFilter.propTypes = NestedTagsFilterProps;

export default NestedTagsFilter;
